import TransportationIcon from './TransportationIcon';
export default TransportationIcon;
